export type CategoryKey = 'movie' | 'tv' | 'variety';

export interface Movie {
  id: string;
  title: string;
  category: CategoryKey;
  genres: string[];
  region: string;
  year: number;
  rating: number;
  heat: number;
  updatedAt: string;
  duration: string;
  director: string;
  cast: string[];
  tagline: string;
  synopsis: string;
  poster: string;
  backdrop?: string;
  featured?: boolean;
}

export const movies: Movie[] = [
  {
    id: 'm01',
    title: '长夜将明',
    category: 'movie',
    genres: ['剧情', '悬疑'],
    region: '中国大陆',
    year: 2025,
    rating: 8.9,
    heat: 986,
    updatedAt: '2026-10-14',
    duration: '124 分钟',
    director: '沈知远',
    cast: ['周牧', '林书瑶', '高维'],
    tagline: '一座不眠的城市，一个不肯放弃的夜晚。',
    synopsis:
      '一场持续七十二小时的暴雨让整座城市陷入停摆，刑警队长郑野在追查一桩旧案时，意外发现所有线索都指向自己曾经的搭档。长夜漫长，真相却在雨声里一点点浮出水面。影片以冷峻的影像与克制的表演，讲述一个人如何在黑暗中守住最后一点光。',
    poster:
      'https://readdy.ai/api/search-image?query=stylized%20cinematic%20movie%20poster%20artwork%20of%20a%20lone%20figure%20standing%20on%20a%20rain%20soaked%20city%20street%20at%20midnight%2C%20deep%20navy%20and%20amber%20palette%2C%20dramatic%20rim%20light%2C%20moody%20atmosphere%2C%20textured%20film%20grain%2C%20minimal%20negative%20space%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=hn-p01&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20wide%20backdrop%20of%20a%20rain%20soaked%20night%20city%20street%20with%20reflections%20and%20a%20lone%20silhouetted%20figure%20walking%20away%2C%20deep%20navy%20blue%20tones%20with%20amber%20street%20lights%2C%20moody%20atmospheric%20haze%2C%20stylized%20illustration%2C%20film%20grain%2C%20no%20text&width=1600&height=900&seq=hn-h01&orientation=landscape',
    featured: true,
  },
  {
    id: 'm02',
    title: '潮汐之城',
    category: 'movie',
    genres: ['爱情', '剧情'],
    region: '中国大陆',
    year: 2024,
    rating: 8.3,
    heat: 742,
    updatedAt: '2026-10-09',
    duration: '112 分钟',
    director: '苏未央',
    cast: ['陈屿', '许清和', '黎梦'],
    tagline: '潮水退去时，我们才看清彼此。',
    synopsis:
      '在一座靠海的小城，摄影师阿澈与电台主播小满因为一次台风天的误拨电话而认识。三年里他们隔着屏幕相爱，也在潮汐般的距离里反复靠近与退让。影片用大量自然光与海雾，记录了一段像潮水一样来的感情。',
    poster:
      'https://readdy.ai/api/search-image?query=stylized%20cinematic%20movie%20poster%20artwork%20of%20a%20coastal%20town%20at%20dawn%20with%20waves%20crashing%20over%20an%20old%20pier%2C%20teal%20and%20warm%20sand%20palette%2C%20soft%20haze%2C%20romantic%20mood%2C%20textured%20painterly%20finish%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=hn-p02&orientation=portrait',
  },
  {
    id: 'm03',
    title: '星际拾荒者',
    category: 'movie',
    genres: ['科幻', '冒险'],
    region: '中国大陆',
    year: 2025,
    rating: 8.6,
    heat: 913,
    updatedAt: '2026-10-13',
    duration: '136 分钟',
    director: '韩立川',
    cast: ['魏然', '程雪', '赵砚'],
    tagline: '在宇宙的垃圾场里，捡到回家的路。',
    synopsis:
      '废弃行星带的拾荒者老K靠拆解残骸维生，直到他从一艘坠毁的飞船里救出一个自称来自地球的女孩。为了送她回家，两人要穿过被废弃的航线与沉默的星门。一部关于孤独、信任和归途的太空公路片。',
    poster:
      'https://readdy.ai/api/search-image?query=stylized%20cinematic%20sci-fi%20movie%20poster%20artwork%20of%20a%20scavenger%20silhouette%20before%20a%20giant%20wrecked%20spacecraft%20on%20a%20dusty%20planet%2C%20deep%20blue%20and%20burnt%20orange%20palette%2C%20volumetric%20light%2C%20textured%20grain%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=hn-p03&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20wide%20backdrop%20of%20a%20vast%20desert%20planet%20with%20a%20colossal%20wrecked%20spaceship%20and%20two%20tiny%20figures%2C%20deep%20blue%20sky%20and%20burnt%20orange%20sand%2C%20dramatic%20volumetric%20light%2C%20stylized%20illustration%2C%20no%20text&width=1600&height=900&seq=hn-h03&orientation=landscape',
    featured: true,
  },
  {
    id: 'm04',
    title: '雾港疑云',
    category: 'movie',
    genres: ['犯罪', '悬疑'],
    region: '中国香港',
    year: 2023,
    rating: 8.1,
    heat: 628,
    updatedAt: '2026-09-22',
    duration: '118 分钟',
    director: '何启南',
    cast: ['梁子谦', '吴绮雯', '杜峰'],
    tagline: '雾散之前，没有人是清白的。',
    synopsis:
      '一艘无名货轮停靠在雾港，船上只剩下一个失忆的水手和一张写满名字的清单。退休警探老周被请回调查，却发现名单上的每个人都已经死了。影片在潮湿的港口与狭窄的货舱之间，织出一张关于旧账与复仇的网。',
    poster:
      'https://readdy.ai/api/search-image?query=stylized%20cinematic%20crime%20thriller%20poster%20artwork%20of%20a%20foggy%20harbor%20with%20a%20single%20crane%20and%20dim%20street%20lamp%2C%20cold%20navy%20and%20amber%20palette%2C%20heavy%20atmosphere%2C%20painterly%20texture%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=hn-p04&orientation=portrait',
  },
  {
    id: 'm05',
    title: '春天不回来',
    category: 'movie',
    genres: ['剧情', '文艺'],
    region: '中国大陆',
    year: 2024,
    rating: 8.4,
    heat: 405,
    updatedAt: '2026-08-30',
    duration: '104 分钟',
    director: '徐念',
    cast: ['温亦然', '苏禾', '老周'],
    tagline: '有人留在原地，也是一种远行。',
    synopsis:
      '小镇车站的最后一班绿皮火车停运了，守站三十年的老顾却仍然每天擦拭长椅。返乡的女儿试图说服他搬去城市，两人在一个春天的等待里，把多年没说出口的话慢慢讲完。安静、克制，却后劲很足。',
    poster:
      'https://readdy.ai/api/search-image?query=stylized%20cinematic%20art%20house%20poster%20artwork%20of%20an%20empty%20rural%20train%20platform%20in%20early%20spring%20with%20falling%20petals%2C%20muted%20olive%20and%20pale%20gold%20palette%2C%20nostalgic%20mood%2C%20film%20grain%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=hn-p05&orientation=portrait',
  },
  {
    id: 'm06',
    title: '极速回响',
    category: 'movie',
    genres: ['动作', '赛车'],
    region: '中国大陆',
    year: 2025,
    rating: 7.8,
    heat: 856,
    updatedAt: '2026-10-11',
    duration: '126 分钟',
    director: '高野',
    cast: ['陆骁', '柯蓝', '陈九'],
    tagline: '引擎声一响，就没有退路。',
    synopsis:
      '曾经的拉力赛冠军因为一次事故退出了赛道，五年后他带着一台拼装车回到山道，只为赢回女儿的一句原谅。影片用实拍山路追逐与真实的机械轰鸣，拍出了国产赛车片少见的硬度和速度感。',
    poster:
      'https://readdy.ai/api/search-image?query=stylized%20cinematic%20action%20movie%20poster%20artwork%20of%20a%20race%20car%20speeding%20through%20a%20mountain%20tunnel%20with%20streaks%20of%20light%2C%20deep%20charcoal%20and%20orange%20palette%2C%20motion%20blur%2C%20dramatic%20contrast%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=hn-p06&orientation=portrait',
  },
  {
    id: 'm07',
    title: '雪山信使',
    category: 'movie',
    genres: ['冒险', '剧情'],
    region: '中国大陆',
    year: 2022,
    rating: 8.7,
    heat: 512,
    updatedAt: '2026-07-18',
    duration: '130 分钟',
    director: '白岩',
    cast: ['木拉提', '卓玛', '刘启'],
    tagline: '路断了，信还要送到。',
    synopsis:
      '大雪封山的季节，高原邮路上的老信使带着年轻的学徒，翻越海拔五千米的垭口，只为把一封信送到山那边的村落。风雪、缺氧、迷路，以及一路上遇到的人，构成了这趟缓慢却动人的旅程。',
    poster:
      'https://readdy.ai/api/search-image?query=stylized%20cinematic%20adventure%20poster%20artwork%20of%20a%20small%20figure%20crossing%20a%20vast%20snowy%20ridge%20at%20sunrise%2C%20cool%20blue%20shadows%20and%20golden%20light%2C%20textured%20painterly%20finish%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=hn-p07&orientation=portrait',
  },
  {
    id: 'm08',
    title: '二十四格的夏天',
    category: 'movie',
    genres: ['青春', '剧情'],
    region: '中国大陆',
    year: 2024,
    rating: 8.0,
    heat: 468,
    updatedAt: '2026-09-05',
    duration: '98 分钟',
    director: '苗青',
    cast: ['顾星野', '夏栀', '林一舟'],
    tagline: '我们把夏天，一帧一帧拍完。',
    synopsis:
      '高三毕业的暑假，四个朋友借来一台老式胶片机，打算拍完一部属于自己的电影。胶片只有二十四格一卷，每一次按下快门都要犹豫很久。那个夏天关于梦想、分别和第一次心动，被定格在略显过曝的画面里。',
    poster:
      'https://readdy.ai/api/search-image?query=stylized%20cinematic%20coming%20of%20age%20poster%20artwork%20of%20teenagers%20on%20bicycles%20under%20summer%20trees%20with%20sunlight%20flare%2C%20warm%20yellow%20and%20green%20palette%2C%20grainy%20film%20look%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=hn-p08&orientation=portrait',
  },
  {
    id: 't01',
    title: '长安旧事',
    category: 'tv',
    genres: ['古装', '历史'],
    region: '中国大陆',
    year: 2025,
    rating: 9.1,
    heat: 1120,
    updatedAt: '2026-10-15',
    duration: '全 42 集',
    director: '陆知行',
    cast: ['裴元', '沈玉书', '柳含烟', '程敬'],
    tagline: '一座城的兴衰，写在每个人的选择里。',
    synopsis:
      '长安城最繁华的一年，一桩发生在西市的命案牵出了朝堂与江湖之间盘根错节的旧账。小吏裴照被卷入其中，从查案到查人，最终查到了自己身上。剧集以扎实的服化道与群像叙事，还原了一个烟火气与杀机并存的盛唐。',
    poster:
      'https://readdy.ai/api/search-image?query=stylized%20cinematic%20historical%20drama%20poster%20artwork%20of%20ancient%20Chinese%20city%20walls%20and%20lanterns%20at%20night%2C%20deep%20crimson%20and%20dark%20navy%20palette%2C%20mist%20and%20falling%20snow%2C%20painterly%20texture%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=hn-p09&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20wide%20backdrop%20of%20an%20ancient%20Chinese%20city%20at%20night%20with%20glowing%20lanterns%2C%20tiled%20rooftops%20and%20mist%2C%20deep%20navy%20and%20warm%20crimson%20palette%2C%20stylized%20illustration%2C%20film%20grain%2C%20no%20text&width=1600&height=900&seq=hn-h09&orientation=landscape',
    featured: true,
  },
  {
    id: 't02',
    title: '边界之外',
    category: 'tv',
    genres: ['刑侦', '悬疑'],
    region: '中国大陆',
    year: 2024,
    rating: 8.8,
    heat: 934,
    updatedAt: '2026-10-10',
    duration: '全 24 集',
    director: '罗青山',
    cast: ['贺明', '唐诗雨', '马骁'],
    tagline: '越过分界线，就再也回不去了。',
    synopsis:
      '边境小城的缉毒队接到一条模糊的线报，随之而来的是一场横跨三省的长线追踪。队长贺川必须在规则与结果之间反复权衡，而他的新搭档似乎隐藏着另一重身份。节奏紧凑，反转扎实。',
    poster:
      'https://readdy.ai/api/search-image?query=stylized%20cinematic%20crime%20series%20poster%20artwork%20of%20a%20detective%20standing%20in%20an%20empty%20industrial%20corridor%20with%20harsh%20light%20slanting%20in%2C%20desaturated%20navy%20and%20steel%20palette%2C%20moody%20grain%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=hn-p10&orientation=portrait',
  },
  {
    id: 't03',
    title: '海雾之下',
    category: 'tv',
    genres: ['悬疑', '都市'],
    region: '中国大陆',
    year: 2025,
    rating: 8.5,
    heat: 788,
    updatedAt: '2026-10-08',
    duration: '全 20 集',
    director: '余清',
    cast: ['江迟', '闻莺', '老K'],
    tagline: '雾里有人，也有不肯说的秘密。',
    synopsis:
      '海岛灯塔看守人的女儿在一次大雾中失踪，二十年后，同一片海域又发生了相似的事件。回到岛上整理遗物的记者发现，母亲留下的航海日志里多出了几页不属于她的字迹。',
    poster:
      'https://readdy.ai/api/search-image?query=stylized%20cinematic%20mystery%20series%20poster%20artwork%20of%20a%20lighthouse%20swallowed%20by%20sea%20fog%20with%20a%20tiny%20boat%2C%20deep%20teal%20and%20pale%20grey%20palette%2C%20eerie%20atmosphere%2C%20textured%20finish%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=hn-p11&orientation=portrait',
  },
  {
    id: 't04',
    title: '我们的十年',
    category: 'tv',
    genres: ['都市', '情感'],
    region: '中国大陆',
    year: 2023,
    rating: 8.2,
    heat: 654,
    updatedAt: '2026-09-18',
    duration: '全 36 集',
    director: '周牧野',
    cast: ['林晚', '程亦', '苏橙'],
    tagline: '十年之后，我们还在同一座城市。',
    synopsis:
      '从大学宿舍到写字楼，从合租屋到第一个家，六个年轻人在十年里经历工作、恋爱、分离和重逢。剧集用细碎的生活细节，记录一代人如何慢慢长成自己曾经想象的样子。',
    poster:
      'https://readdy.ai/api/search-image?query=stylized%20cinematic%20urban%20drama%20poster%20artwork%20of%20a%20couple%20silhouette%20on%20a%20rooftop%20above%20warm%20city%20lights%20at%20dusk%2C%20muted%20blue%20and%20amber%20palette%2C%20nostalgic%20grain%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=hn-p12&orientation=portrait',
  },
  {
    id: 't05',
    title: '无声证词',
    category: 'tv',
    genres: ['律政', '剧情'],
    region: '中国大陆',
    year: 2024,
    rating: 8.9,
    heat: 702,
    updatedAt: '2026-09-28',
    duration: '全 28 集',
    director: '方序',
    cast: ['闻舟', '许知遥', '邵川'],
    tagline: '不是所有的沉默，都代表认罪。',
    synopsis:
      '一位习惯替弱者辩护的律师，接手了一桩没有目击者、没有物证、只有一段模糊监控的案件。当所有人都在催促结案，他坚持要找到那个没有开口的人。法庭戏锋利，情感戏克制。',
    poster:
      'https://readdy.ai/api/search-image?query=stylized%20cinematic%20legal%20drama%20poster%20artwork%20of%20an%20empty%20courtroom%20with%20light%20beams%20through%20tall%20windows%2C%20cool%20grey%20and%20deep%20navy%20palette%2C%20solemn%20atmosphere%2C%20textured%20finish%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=hn-p13&orientation=portrait',
  },
  {
    id: 't06',
    title: '山间诊所',
    category: 'tv',
    genres: ['医疗', '温情'],
    region: '中国大陆',
    year: 2022,
    rating: 8.6,
    heat: 388,
    updatedAt: '2026-06-20',
    duration: '全 26 集',
    director: '陈可',
    cast: ['苏木', '阿依', '老李'],
    tagline: '山路很远，人心很近。',
    synopsis:
      '年轻医生主动申请到山区诊所轮岗，原本只打算待三个月。交通不便、药品短缺、村民的不信任，一点点磨掉了她的耐心，也一点点让她留下来。一部慢热但温暖的作品。',
    poster:
      'https://readdy.ai/api/search-image?query=stylized%20cinematic%20warm%20drama%20poster%20artwork%20of%20a%20small%20mountain%20clinic%20with%20a%20lantern%20glowing%20at%20dusk%2C%20soft%20green%20and%20warm%20gold%20palette%2C%20gentle%20mood%2C%20painterly%20texture%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=hn-p14&orientation=portrait',
  },
  {
    id: 't07',
    title: '逆风少年',
    category: 'tv',
    genres: ['青春', '运动'],
    region: '中国大陆',
    year: 2025,
    rating: 8.4,
    heat: 902,
    updatedAt: '2026-10-14',
    duration: '全 30 集',
    director: '于野',
    cast: ['沈澈', '梁小满', '教练周'],
    tagline: '跑得慢没关系，别停下来。',
    synopsis:
      '县中学的短跑队在省级比赛前失去了主力，教练只好把从未上过赛道的替补推上去。少年们在训练场上一次次摔倒、一次次重来，最终跑出了属于自己的成绩。燃点密集，也很真诚。',
    poster:
      'https://readdy.ai/api/search-image?query=stylized%20cinematic%20sports%20drama%20poster%20artwork%20of%20a%20young%20runner%20sprinting%20on%20a%20track%20at%20sunset%2C%20dynamic%20motion%2C%20orange%20and%20deep%20blue%20palette%2C%20grainy%20texture%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=hn-p15&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20wide%20backdrop%20of%20a%20running%20track%20at%20sunset%20with%20motion%20streaks%20and%20a%20sprinter%20silhouette%2C%20deep%20blue%20shadows%20and%20intense%20orange%20sky%2C%20stylized%20illustration%2C%20no%20text&width=1600&height=900&seq=hn-h15&orientation=landscape',
    featured: true,
  },
  {
    id: 't08',
    title: '城南食光',
    category: 'tv',
    genres: ['美食', '家庭'],
    region: '中国大陆',
    year: 2024,
    rating: 8.7,
    heat: 566,
    updatedAt: '2026-08-26',
    duration: '全 22 集',
    director: '黄亦然',
    cast: ['何叔', '小满', '阿德'],
    tagline: '一碗面，煮了三十年。',
    synopsis:
      '城南老街的面馆要拆迁了，老板何叔打算关店，儿子却想把它留下来。一间小店、一条街坊、几十年的味道，剧集用一日三餐串起了普通人的悲欢。',
    poster:
      'https://readdy.ai/api/search-image?query=stylized%20cinematic%20family%20drama%20poster%20artwork%20of%20a%20cozy%20noodle%20shop%20interior%20at%20night%20with%20steam%20rising%2C%20warm%20amber%20and%20deep%20red%20palette%2C%20intimate%20mood%2C%20film%20grain%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=hn-p16&orientation=portrait',
  },
  {
    id: 'v01',
    title: '声浪撞地球',
    category: 'variety',
    genres: ['音乐', '竞演'],
    region: '中国大陆',
    year: 2025,
    rating: 8.5,
    heat: 1046,
    updatedAt: '2026-10-16',
    duration: '每周五更新',
    director: '黄牛视频自制',
    cast: ['阿岚', '周野', '麦子', 'TC 乐队'],
    tagline: '把音量调到最大，让世界听见。',
    synopsis:
      '一档以现场演出为核心的音乐竞演节目，六十位来自不同圈层的音乐人同台合作、改编、对决。没有修音，没有预录，每一期都是一次真正的现场。',
    poster:
      'https://readdy.ai/api/search-image?query=stylized%20music%20variety%20show%20poster%20artwork%20of%20a%20stage%20with%20microphone%20in%20a%20beam%20of%20light%20and%20floating%20sound%20waves%2C%20deep%20navy%20and%20neon%20orange%20palette%2C%20energetic%20mood%2C%20textured%20finish%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=hn-p17&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20wide%20backdrop%20of%20a%20concert%20stage%20with%20beams%20of%20light%20cutting%20through%20haze%20and%20a%20microphone%20stand%2C%20deep%20navy%20and%20vivid%20orange%20palette%2C%20stylized%20illustration%2C%20no%20text&width=1600&height=900&seq=hn-h17&orientation=landscape',
    featured: true,
  },
  {
    id: 'v02',
    title: '出发吧朋友',
    category: 'variety',
    genres: ['旅行', '真人秀'],
    region: '中国大陆',
    year: 2024,
    rating: 8.2,
    heat: 812,
    updatedAt: '2026-10-07',
    duration: '每周六更新',
    director: '黄牛视频自制',
    cast: ['大鹏', '阿May', '老陈'],
    tagline: '不设目的地，只带一个朋友。',
    synopsis:
      '三位性格完全不同的主持人开着一辆旧房车，沿着海岸线一路向南。没有剧本，没有攻略，遇到什么就拍什么。旅途中的尴尬、争执和和解，比风景更有意思。',
    poster:
      'https://readdy.ai/api/search-image?query=stylized%20travel%20variety%20show%20poster%20artwork%20of%20a%20camper%20van%20on%20a%20winding%20coastal%20road%20at%20golden%20hour%2C%20sky%20blue%20and%20warm%20orange%20palette%2C%20playful%20mood%2C%20painterly%20texture%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=hn-p18&orientation=portrait',
  },
  {
    id: 'v03',
    title: '喜剧工坊',
    category: 'variety',
    genres: ['喜剧', '脱口秀'],
    region: '中国大陆',
    year: 2025,
    rating: 8.8,
    heat: 968,
    updatedAt: '2026-10-13',
    duration: '每周四更新',
    director: '黄牛视频自制',
    cast: ['老段', '小鹿', '阿福', '七七'],
    tagline: '生活很难，但可以笑。',
    synopsis:
      '一档以原创段子为核心的喜剧节目，新人演员在工坊里打磨文本，每周上台接受观众投票。笑点来自加班、相亲、房租和老家，真实得让人有点想哭。',
    poster:
      'https://readdy.ai/api/search-image?query=stylized%20comedy%20show%20poster%20artwork%20of%20a%20spotlight%20on%20an%20empty%20stage%20with%20a%20vintage%20microphone%2C%20deep%20burgundy%20and%20warm%20gold%20palette%2C%20playful%20retro%20mood%2C%20textured%20finish%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=hn-p19&orientation=portrait',
  },
  {
    id: 'v04',
    title: '厨房大乱斗',
    category: 'variety',
    genres: ['美食', '竞技'],
    region: '中国大陆',
    year: 2024,
    rating: 8.0,
    heat: 723,
    updatedAt: '2026-09-24',
    duration: '每周日更新',
    director: '黄牛视频自制',
    cast: ['主厨林', '阿泰', '小甜'],
    tagline: '三十分钟，一口锅，一场战争。',
    synopsis:
      '素人厨艺爱好者与专业主厨同台竞技，每期只有三十分钟和一个神秘食材。有人做出惊喜，有人把厨房点着了。节目用最直接的烟火气，讲最朴实的热爱。',
    poster:
      'https://readdy.ai/api/search-image?query=stylized%20cooking%20competition%20poster%20artwork%20of%20a%20flaming%20wok%20and%20fresh%20ingredients%20on%20a%20dark%20counter%2C%20warm%20orange%20and%20deep%20navy%20palette%2C%20energetic%20mood%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=hn-p20&orientation=portrait',
  },
  {
    id: 'v05',
    title: '推理现场',
    category: 'variety',
    genres: ['推理', '悬疑'],
    region: '中国大陆',
    year: 2025,
    rating: 8.9,
    heat: 891,
    updatedAt: '2026-10-12',
    duration: '每周三更新',
    director: '黄牛视频自制',
    cast: ['沈默', '阿七', '顾言', '编外侦探'],
    tagline: '每个房间都有一句谎话。',
    synopsis:
      '六位玩家进入一个完整搭建的实景案件现场，通过搜证、问询和推理找出真凶。这一季的场景从老式旅馆换到了远洋邮轮，谜题更复杂，人性也更难猜。',
    poster:
      'https://readdy.ai/api/search-image?query=stylized%20mystery%20variety%20show%20poster%20artwork%20of%20a%20dim%20room%20with%20a%20table%20lamp%20and%20scattered%20case%20files%2C%20dark%20teal%20and%20amber%20palette%2C%20suspenseful%20mood%2C%20textured%20finish%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=hn-p21&orientation=portrait',
  },
  {
    id: 'v06',
    title: '舞力全开夜',
    category: 'variety',
    genres: ['舞蹈', '竞演'],
    region: '中国大陆',
    year: 2023,
    rating: 8.1,
    heat: 604,
    updatedAt: '2026-07-30',
    duration: '全 12 期',
    director: '黄牛视频自制',
    cast: ['阿KEN', 'Nana', 'Zoe'],
    tagline: '音乐响起，身体先说话。',
    synopsis:
      '街舞、现代舞、民族舞的舞者被随机组队，在四十八小时内完成一支全新的作品。编舞的碰撞、体力的极限和舞台上的那三分钟，构成了整个夏天最热血的记忆。',
    poster:
      'https://readdy.ai/api/search-image?query=stylized%20dance%20competition%20poster%20artwork%20of%20dancers%20mid%20pose%20under%20dramatic%20stage%20light%2C%20deep%20indigo%20and%20warm%20pink%20palette%2C%20motion%20energy%2C%20grainy%20texture%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=hn-p22&orientation=portrait',
  },
  {
    id: 'v07',
    title: '我们的乡村日记',
    category: 'variety',
    genres: ['生活', '纪实'],
    region: '中国大陆',
    year: 2024,
    rating: 8.6,
    heat: 437,
    updatedAt: '2026-08-15',
    duration: '全 10 期',
    director: '黄牛视频自制',
    cast: ['阿禾', '老吴', '小满'],
    tagline: '把日子过慢一点，也没什么不好。',
    synopsis:
      '三位年轻人用一年时间住进南方山村，跟着村民插秧、养蜂、修屋顶、赶集。没有任务，也没有赛制，只记录四季变化和一日三餐。看完会想给家里打个电话。',
    poster:
      'https://readdy.ai/api/search-image?query=stylized%20documentary%20variety%20poster%20artwork%20of%20golden%20rice%20fields%20with%20a%20small%20farmhouse%20at%20sunset%2C%20warm%20green%20and%20gold%20palette%2C%20peaceful%20mood%2C%20painterly%20texture%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=hn-p23&orientation=portrait',
  },
  {
    id: 'v08',
    title: '演技实验室',
    category: 'variety',
    genres: ['表演', '竞技'],
    region: '中国大陆',
    year: 2025,
    rating: 8.3,
    heat: 551,
    updatedAt: '2026-09-11',
    duration: '每周一更新',
    director: '黄牛视频自制',
    cast: ['顾导', '陈砚', '林小满'],
    tagline: '一条过，或者再来二十条。',
    synopsis:
      '演员在没有完整剧本的情况下进入片场，只拿到一页人物小传和一句台词。每一次开拍都是即兴，每一次喊卡都可能重来。节目把表演这件事拆开给人看。',
    poster:
      'https://readdy.ai/api/search-image?query=stylized%20acting%20competition%20poster%20artwork%20of%20a%20theatre%20stage%20with%20a%20single%20chair%20under%20a%20spotlight%2C%20dark%20navy%20and%20warm%20white%20palette%2C%20dramatic%20mood%2C%20textured%20finish%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=hn-p24&orientation=portrait',
  },
];